import * as React from "react";
import { forwardRef } from "react";
const InfoIcon = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", Object.assign({
  xmlns: "http://www.w3.org/2000/svg",
  "aria-hidden": "true",
  viewBox: "0 0 16 16",
  fill: "currentColor",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M16 8c0 4.4183-3.5817 8-8 8-4.41828 0-8-3.5817-8-8 0-4.41828 3.58172-8 8-8 4.4183 0 8 3.58172 8 8M6.85715 6.85713h2.28571v5.71427H6.85715zm2.28571-3.42855H6.85715v2.28571h2.28571z",
  clipRule: "evenodd"
}));
const ForwardRef = forwardRef(InfoIcon);
export { ForwardRef as InfoIcon };